module.exports = __webpack_public_path__ + "img/img_adv.6737ad53.png";